import { SearchInvalidations } from "@/redux/modules/value/search/search.types";
import {
    SearchComponent,
    SearchComponentEnum,
    SearchComponents
} from "@/utils/search/types/searchComponent";

type ComponentInvalidationMap = Partial<
    Record<SearchComponentEnum, SearchInvalidations>
>;

const componentInvalidationMap: ComponentInvalidationMap = {
    [SearchComponent.PRODUCT_HITS_PER_PAGE]: {
        configuration: [SearchComponent.PRODUCT_PAGINATION],
        state: [SearchComponent.PRODUCT_RESULT_LIST]
    },
    [SearchComponent.PRODUCT_SORT]: {
        configuration: [SearchComponent.PRODUCT_PAGINATION],
        state: [SearchComponent.PRODUCT_RESULT_LIST]
    },
    [SearchComponent.PRODUCT_FACETS]: {
        configuration: [SearchComponent.PRODUCT_PAGINATION],
        state: [SearchComponent.PRODUCT_RESULT_LIST]
    },
    [SearchComponent.CONTENT_HITS_PER_PAGE]: {
        configuration: [SearchComponent.CONTENT_PAGINATION],
        state: [SearchComponent.CONTENT_RESULT_LIST]
    }
};

export const getInvalidationsForComponent = (
    component: SearchComponentEnum
): SearchInvalidations => {
    const componentInvalidations = componentInvalidationMap[component];
    return {
        state: componentInvalidations?.state ?? [],
        configuration: componentInvalidations?.configuration ?? []
    };
};

export const INVALIDATE_ALL: SearchInvalidations = {
    configuration: SearchComponents.ALL,
    state: SearchComponents.ALL
};
